import styles from "@/styles/Catalogue.module.css";
import { Castle, Game, Other, Tent, Darts, Database } from "./Database";
import CatalogueChoiceCell from "./CatalogueChoiceCell";
import CatalogueRequestCell from "./CatalogueRequestCell";
import CatalogueCell from "./CatalogueCell";
import Link from "next/link";

type CatalogueProps = {
  type: "rent" | "rent-multiple" | "buy";
  content: "castle" | "game" | "other" | "tent" | "darts";
  title: string;
  shoutout?: string;
  database: Database;
  link?: string;
  linkText?: string;
};

export default function Catalogue({ type, content, title, shoutout, database, link, linkText }: CatalogueProps) {
  const allContent = database.castles.concat(database.games);
  if (type === "rent") {
    switch (content) {
      case "castle":
        return (
          <div className={styles.catalogue}>
            <div className={styles.titleBox}>
              <h2>{title}</h2>
              {link && <Link href={link} className={styles.multipleLink}>{linkText}</Link>}
            </div>
            <div className={styles.catalogueContent}>
              {database &&
                database.castles.map((castle) => {
                  if (castle.rent) {
                    return <CatalogueChoiceCell key={castle.nameNL} type="rent" content={castle} />;
                  }
                })}
            </div>
          </div>
        );
      case "game":
        return (
          <div className={styles.catalogue}>
            <h2>{title}</h2>
            <div className={styles.catalogueContent}>
              {database &&
                database.games.map((game) => {
                  if (game.rent) {
                    return <CatalogueChoiceCell key={game.nameNL} type="rent" content={game} />;
                  }
                })}
            </div>
          </div>
        );
      case "other":
        return (
          <div className={styles.catalogue}>
            <h2>{title}</h2>
            <div className={styles.catalogueContent}>
              {database &&
                database.other.map((other) => {
                  return (
                    <CatalogueRequestCell
                      key={other.nameNL}
                      type="other"
                      content={other as Other}
                    />
                  );
                })}
            </div>
          </div>
        );
      case "tent":
        return (
          <div className={styles.catalogue}>
            <h2>{title}</h2>
            <Link href={"https://www.fantentic.be"} target="_blank">{shoutout}</Link>
            <div className={styles.catalogueContent}>
              {database &&
                database.tent.map((tent) => {
                  return (
                    <CatalogueRequestCell key={tent.nameNL} type="tent" content={tent as Tent} />
                  );
                })}
            </div>
          </div>
        );
      case "darts":
        return (
          <div className={styles.catalogue}>
            <h2>{title}</h2>
            <Link href={"https://www.facebook.com/share/1EBrmU58iS/?mibextid=wwXIfr"} target="_blank">{shoutout}</Link>
            {database && database.darts.length === 0 && <h3>Coming soon!</h3>}
            <div className={styles.catalogueContent}>
              {database &&
                database.darts.map((darts) => {
                  return (
                    <CatalogueRequestCell key={darts.nameNL} type="darts" content={darts as Darts} />
                  );
                })}
            </div>
          </div>
        );
    }
  } else if (type === "rent-multiple") {
    switch (content) {
      case "castle":
        return (
          <div className={styles.catalogue}>
            <h2>{title}</h2>
            <div className={styles.catalogueContent}>
              {database &&
                database.castles.map((castle) => {
                  if (castle.rent) {
                    return <CatalogueCell key={castle.nameNL} content={castle} />;
                  }
                })}
            </div>
          </div>
        );
      case "game":
        return (
          <div className={styles.catalogue}>
            <h2>{title}</h2>
            <div className={styles.catalogueContent}>
              {database &&
                database.games.map((game) => {
                  if (game.rent) {
                    return <CatalogueCell key={game.nameNL} content={game} />;
                  }
                })}
            </div>
          </div>
        );
      }
  } else if (type === "buy") {
    return (
      <div className={styles.catalogue}>
        <div className={styles.catalogueContent}>
          {allContent.map((content) => {
            if (content.buy) {
              return (
                <CatalogueChoiceCell
                  key={content.nameNL}
                  type="buy"
                  content={content as Game | Castle}
                />
              ); // Moet waarschijnlijk aparte component voor komen
            }
          })}
        </div>
      </div>
    );
  }
}
